<template>
  <div class="theme-download" 
  >
  <!-- data-vv-value-path="model" -->

    <input
      class="theme-download__input"
      :class="{ 'theme-download__input--white': white }"
      type="file"
      :name="name"
      accept="application/pdf, image/*"
      />
      <!-- @change="$emit('change', $event)" -->
      <!-- v-validate="`required`" -->
      <!-- valid-scope="booking-form" -->
    <span class="icon-upload theme-download__icon"></span>
  </div>
</template>

<script>
import field from '../admin/mixins/field'

export default {
  mixins: [field],
  props: {
    white: {
      default: false,
      type: Boolean,
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/js/components/ThemeDownload.vue